var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('div',{staticClass:"titbox"},[_c('p',{staticClass:"commp3 sub_title fwb"},[_vm._v("자동보고서")])]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }